export type ProcessStatus =
  'NOT_STARTED' |
  'PENDING' |
  "NOT_LOGGED_IN" |
  "OTHER_PARTY";


export interface FieldConfig {
  name: string;
  label: string;
  descr: string;
  type: 'text' | 'number' | 'date' | 'select' | 'checkbox' | 'radio'|'textarea'|"hideform";
  required: boolean;
  fullsize: boolean;
  options?: string[]; // For select and radio fields
  value: any;
  disabled?: boolean;
}

export const send_starting_requirements: FieldConfig[] = [
  { name: 'material', label: 'Material', type: 'text', required: true, value: '', descr: '',fullsize: false },
  { name: 'color', label: 'Color', type: 'text', required: true, value: '', descr: '',fullsize: false },
  { name: 'normative', label: 'Normative', type: 'text', required: true, value: '', descr: '',fullsize: true },
  { name: 'trusted', label: 'yes', type: 'checkbox', required: false, value: false, descr: 'do you want to work with somebody you already know?',fullsize: true }, 
  { name: 'maxDistance', label: 'Max Distance', type: 'number', required: true, value: 0, descr: '',fullsize: false },
  { name: 'deliveryDate', label: 'Delivery Date', type: 'date', required: true, value: null, descr: '',fullsize: false },
  { name: 'sourceMaterial', label: 'Source Material', type: 'text', required: true, value: '', descr: '',fullsize: false },
  { name: 'priceLimit', label: 'Price Limit', type: 'number', required: true, value: 0, descr: '',fullsize: false },
  { name: 'minReputation', label: 'Min Reputation', type: 'number', required: true, value: 0, descr: '',fullsize: true }
];

export const risk_assessment_requirements: FieldConfig[] = [
  { name: 'visitNeeded', label: 'Visit Needed', type: 'checkbox', required: false, value: false, descr: 'how do you want to conduct the risk assessment for each of them? (please select one or more criteria to continue)',fullsize: true },
  { name: 'selfAssessmentNeeded', label: 'Self Assessment Needed', type: 'checkbox', required: false, value: false, descr: '',fullsize: false },
  { name: 'evidenceNeeded', label: 'Evidence Needed', type: 'checkbox', required: false, value: false, descr: '',fullsize: false }
];

export const  fill_risk_assessment_criteria : FieldConfig[] = [
  { name: 'hideform', label: 'Some Rules', type: 'hideform', required: true, value: '', descr: '',fullsize: false },
 
  

];





export const run_risk_assessment_rules: FieldConfig[] = [
  { name: 'someRules', label: 'Some Rules', type: 'text', required: true, value: '', descr: '',fullsize: false },
  { name: 'riskAssessmentScore', label: 'Risk Assessment Score', type: 'number', required: true, value: 0, descr: '',fullsize: false }
];



export const evaluate_sample: FieldConfig[] = [
  { name: 'score', label: 'Score', type: 'number', required: true, value: 0, descr: '',fullsize: false }
];


export const evaluate_supplier_response: FieldConfig[] = [
  { name: 'visitExpected', label: 'Yes', type: 'checkbox', required: false, value: '', descr: 'Did your visit go as expected?', fullsize: true },
  { name: 'visitScore', label: 'Assign a score to evaluate your experience', type: 'number', required: true, value: 0, descr: '', fullsize: true },
  { name: 'visitComments', label: 'Do you want to provide comments?', type: 'textarea', required: false, value: '', descr: '', fullsize: true },
  { name: 'sampleReceived', label: 'Yes', type: 'checkbox', required: false, value: '', descr: 'did you get the sample? ', fullsize: true },
  { name: 'sampleScore', label: 'Assign a score to evaluate the quality of the sample', type: 'number', required: true, value: 0, descr: '', fullsize: true },
  { name: 'sampleComments', label: 'Do you want to provide comments?', type: 'textarea', required: false, value: '', descr: '', fullsize: true }
];

export const escalate_indeterminate_case: FieldConfig[] = [
  { name: 'onboard', label: 'On board or reject the supplier', type: 'checkbox', required: false, value: false, descr: 'please review the material submitted and decide whether to accept or reject this option for contracting this supplier', fullsize: true },
 
];



export const suggest_onboard_supplier: FieldConfig[] = [
  
  { name: 'qualifySupplier', label: 'Accept?', type: 'checkbox', required: false, value: '', descr: '', fullsize: true }
];

export const suggest_reject_supplier: FieldConfig[] = [ 
  { name: 'qualifySupplier', label: 'Accept', type: 'checkbox', required: false, value: false, descr: '', fullsize: true }
];

export const formsObject: { [key: string]: FieldConfig[] } = {
  send_starting_requirements: send_starting_requirements,
  risk_assessment_requirements: risk_assessment_requirements,
  run_risk_assessment_rules: run_risk_assessment_rules,  
  evaluate_sample: evaluate_sample, 
  escalate_indeterminate_case: escalate_indeterminate_case,
  fill_risk_assessment_criteria:fill_risk_assessment_criteria,
  evaluate_supplier_response: evaluate_supplier_response,
  suggest_onboard_supplier: suggest_onboard_supplier,
  suggest_reject_supplier:suggest_reject_supplier
};

export  const formsObjectTitles: { [key: string]: string } = {
  send_starting_requirements: "Define Order Requirements",
  risk_assessment_requirements: "Select Supplier",
  run_risk_assessment_rules: "Place Order",

};

export class StartProcessPayload {
  definitionKey: string;
  businessKey: string;
  variables: Record<string, any>;

  constructor(email: string) {
    this.definitionKey = 'VOE'; 
    this.businessKey = email; // Use the provided email as the businessKey
    this.variables = {}; // Initialize variables as an empty object
  }
}


export class AssessmentNeedsClass {
  evidenceNeeded: boolean;
  visitNeeded: boolean;
  selfAssessmentNeeded: boolean;
  riskAssessmentScore: number;
  score: number;
  qualifySupplier: boolean;
  totalAssessmentScoreXLSX: number;
  sampleScore: number;
  sampleComments: string;
  visitScore: number;
  visitComments: string;

  constructor() {
    this.evidenceNeeded = false;
    this.visitNeeded = false;
    this.selfAssessmentNeeded = false;
    this.riskAssessmentScore = 0;
    this.score = 0;
    this.qualifySupplier = false;
    this.totalAssessmentScoreXLSX = 0;
    this.sampleScore = 0;
    this.sampleComments = '';
    this.visitScore = 0;
    this.visitComments = '';
  }
}

export interface FormCompletionStatus {
  formCompletionStatusId: string;
  businessKey: string;
  formName: string;
  assignedTo: string;
  status: "pending" | "completed";
  processInstanceId:string;
}

export interface UserInvolvement {
  businessKey: string;
  isInvolved: boolean;
  assignedTo: string;
}

export interface FormInfo {
  businessKey: string;
  formName: string;
  assignedTo: string; // Assuming assignedTo should be a string
}






